import { washingReportQueryKeys } from 'src/query-keys'
import { WashingReportDto } from '../generated-types/washing-report-dto'
import { queryClient } from '../query-client'
import { IPaginatedResult } from './paginated-result'
import { useDelete, useGet, usePost, usePut } from './reactQuery'

const baseUrl = (mainComponentId: EntityId) => `main-component/${mainComponentId}/washing-reports`

export const washingReportEndpoints = {
  getWashingReports(mainComponentId: EntityId) {
    return `${baseUrl(mainComponentId)}`
  },
  getWashingReportById(mainComponentId: EntityId, id: EntityId) {
    return `${baseUrl(mainComponentId)}/${id}`
  },
  createWashingReport(mainComponentId: EntityId) {
    return `${baseUrl(mainComponentId)}`
  },
  updateWashingReport(mainComponentId: EntityId, id: EntityId) {
    return `${baseUrl(mainComponentId)}/${id}`
  },
  deleteWashingReport(mainComponentId: EntityId) {
    return `${baseUrl(mainComponentId)}`
  },
}

export const invalidateWashingReportCache = {
  getWashingReports(mainComponentId?: EntityId) {
    queryClient.invalidateQueries(washingReportQueryKeys.GET_WASHING_REPORTS(mainComponentId))
  },
  getWashingReportById(mainComponentId: EntityId, id: EntityId) {
    queryClient.invalidateQueries(washingReportEndpoints.getWashingReportById(mainComponentId, id))
  },
}

export const useGetWashingReports = (mainComponentId: EntityId, page = 0, pageSize = 10) =>
  useGet<IPaginatedResult<WashingReportDto>>(washingReportEndpoints.getWashingReports(mainComponentId), {
    page,
    pageSize,
  })

export const useGetWashingReportById = (mainComponentId: EntityId, id: EntityId) =>
  useGet<WashingReportDto>(washingReportEndpoints.getWashingReportById(mainComponentId, id))

export const useCreateWashingReport = (mainComponentId: EntityId) =>
  usePost<WashingReportDto, WashingReportDto>(washingReportEndpoints.createWashingReport(mainComponentId))

export const useUpdateWashingReport = (mainComponentId: EntityId, id: EntityId) =>
  usePut<WashingReportDto, WashingReportDto>(washingReportEndpoints.updateWashingReport(mainComponentId, id))

export const useDeleteWashingReport = (mainComponentId: EntityId) =>
  useDelete<WashingReportDto>(washingReportEndpoints.deleteWashingReport(mainComponentId))
